import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: 'https://6776ce11e58702345be11b48f64064ef@o4511104193331200.ingest.us.sentry.io/4511104288423936',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    // Capture failed outgoing fetch/XHR calls (4xx/5xx) as Sentry events
    Sentry.httpClientIntegration(),
  ],
  tracesSampleRate: 1,
  // Propagate trace headers to your own API routes only
  tracePropagationTargets: ['app.solariis.com', /^\/api\//],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: true,
  enableLogs: true,
  environment: process.env.NODE_ENV ?? 'production',
  // NEXT_PUBLIC_SENTRY_RELEASE is injected at build time by CI (set to github.sha)
  release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
